import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-date-info-item',
    templateUrl: './date-info-item.component.html',
    styleUrls: ['./date-info-item.component.css'],
    imports: [DatePipe, TranslateModule]
})
export class DateInfoItemComponent {

  @Input() isAnEvent = false
  @Input() startDate
  @Input() endDate
  @Input() closeReservationsDate
}
